module.exports = __webpack_public_path__ + "static/media/ipose.67845a6e.svg";